import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';

const Dropdown = styled.div`
    position:relative;
`

const Label = styled.div`
    margin-bottom:10px;
    text-transform:uppercase;
    font-family:'Montserrat', sans-serif;
    font-size:.8125rem;
    font-weight:700;
`

const OptionsList = styled.ul`
    display:none;
    position:absolute;
    top:100%;
    left:0;
    width:100%;
    max-height:320px;
    margin:0;
    padding:0;
    border-bottom-left-radius:5px;
    border-bottom-right-radius:5px;
    list-style-type:none;
    overflow-y:auto;
    background:#fff;
    box-sizing:border-box;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
`

const Trigger = styled.button`
    position:relative;
    width:100%;
    height: 3.125rem;
    border: 1px solid #D5D5D5;
    border-radius: 5px;
    padding: 1.0625rem 2.5rem 1.0625rem 0.6875rem;
    background-color: #F8F8F8;
    font-weight:300;
    text-align:left;
    cursor:pointer;
    white-space:nowrap;
    text-overflow:ellipsis;
    -webkit-appearance:none;
    transition:box-shadow .3s ease-in-out;

    &:after {
        content:'';
        position:absolute;
        top:1.25rem;
        right:1rem;
        border:6px solid transparent;
        border-top-color:#053b83;
    }

    &.active {
        border-bottom-right-radius:0;
        border-bottom-left-radius:0;
    }

    &.active + ${OptionsList} {
        display:block;
    }

    &:focus-visible {
        outline:0;
        box-shadow:inset 0 0 0 0.2rem rgba(134,38,51,1);
    }
`

const Option = styled.li`
    border-top:1px solid #ccc;

    &:first-child {
        border-top:0;
    }
`

const Value = styled.button`
    display:block;
    width:100%;
    border:0;
    padding:10px;
    background:none;
    text-align:left;
    cursor:pointer;
`

const FauxDropdown = (props) => {
    const [isActive, setActive] = useState(false);
    const [value, setValue] = useState(null);
    const [placeholder, setPlaceholder] = useState(props.placeholder);
    const componentRef = useRef();


    const toggleClass = () => {
        setActive(!isActive);
    }

    const OptionSelected = (passedValue, passedLabel) => {
        if(passedValue !== value){
            setValue(passedValue);
            setPlaceholder(passedLabel);
            props.onSelection(passedValue);
        }

        toggleClass();
    }

    useEffect(() => {
        if(isActive){
            document.addEventListener("click", handleClick);
            return () => document.removeEventListener("click", handleClick);

            function handleClick(e) {
                if(componentRef && componentRef.current){
                    if(!componentRef.current.contains(e.target)){
                        toggleClass();
                    }
                }
            }
        }
    },[isActive])

    if(props.options && props.options.length){
    return(
        <Dropdown className="faux-dropdown" ref={componentRef}>
            <Label className="faux-dropdown__label">{props.label}</Label>
            <Trigger type="button" onClick={toggleClass} className={`faux-dropdown__trigger${isActive ? ' active' : ''}`} data-value={value}>{placeholder}</Trigger>
            <OptionsList className="faux-dropdown__options">
                    {props.options.map((o) => {
                        return (
                            <Option className="faux-dropdown__option" key={o.Value}>
                                <Value 
                                    type="button" 
                                    className="faux-dropdown__option-value" 
                                    data-value={o.Value} 
                                    onClick={() => OptionSelected(o.Value, o.Label)}>
                                    {o.Label}
                                </Value>
                            </Option>
                        )
                })}
            </OptionsList>
        </Dropdown>
    )
}
    else {
        return null;
    }
}

export default FauxDropdown;